import useDateFormat from '../../hooks/useDateFormat';

export default function DateFormat({ isoDateFormattedString, dateFormatTransKey }) {
    return useDateFormat(isoDateFormattedString, dateFormatTransKey);
}
